import { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Layout, Dropdown } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Logo from "../assets/images/logo.png";
import PropTypes from "prop-types";
import { useCurrentUser } from "../../app/hooks/useCurrentUser";
import { logout } from "../services/auth";
import SearchBar from "../../components/common/searchBar";

const { Header, Content } = Layout;

const PrivateLayout = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  const { currentUser, isLoading, role } = useCurrentUser();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleLinkClick = () => {
    setIsDrawerOpen(false);
  };

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  PrivateLayout.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const items = [
    {
      key: "1",
      label: (
        <p rel="noopener noreferrer" onClick={logout}>
          Logout
        </p>
      ),
    },
  ];

  if (isLoading || !currentUser?.isLoggedIn) return <></>;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <div className="navigationContainer">
        <Header className="w-full" style={{ backgroundColor: "#2C2C2C" }}>
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className=" flex items-start">
              <button className="text-xl mr-4 lg:hidden" onClick={toggleDrawer} style={{ color: "black" }}>
                &#9776;
              </button>
              <a href="/" rel="noopener noreferrer">
                <img src={Logo} alt="Your Logo" style={{ width: "200px" }} className="flex justify-start" />
              </a>
            </div>
            <nav className="hidden lg:flex flex-1 justify-end items-center gap-10 px-2 flex-nowrap">
              <Link to="/" className="whitespace-nowrap" style={{ color: isActive("/") ? "#ff7201" : "white" }}>
                Dashboard
              </Link>

              <Link to="/event-request" className="whitespace-nowrap" style={{ color: isActive("/event-request") ? "#ff7201" : "white" }}>
                Manpower/Event Request
              </Link>

              {role.includes("Project Manager") ? null : (
                <Link to="/employees" className="whitespace-nowrap" style={{ color: isActive("/employees") ? "#ff7201" : "white" }}>
                  Employees
                </Link>
              )}

              <Link to="/user-management" className="whitespace-nowrap" style={{ color: isActive("/user-management") ? "#ff7201" : "white" }}>
                User Management
              </Link>

              <Link to="/recruitment" className="whitespace-nowrap" style={{ color: location.pathname.startsWith("/recruitment") ? "#ff7201" : "white" }}>
                Recruitment
              </Link>
            </nav>
            <div className="flex items-start gap-4 ml-2">
              <div className="ml-2">
                <SearchBar />
              </div>
              <Dropdown menu={{ items }}>
                <div
                  style={{
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 13,
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  {currentUser.user.employeeInfo != null ? (
                    <img src={currentUser.user.employeeInfo.profileImagePath} alt="USER" style={{ height: "40px", width: "40px" }} className="m-0 p-0" />
                  ) : (
                    <UserOutlined style={{ fontSize: "24px", color: "black" }} />
                  )}
                </div>
              </Dropdown>
            </div>
          </div>
        </Header>
      </div>

      {isDrawerOpen && (
        <div
          className="lg:hidden fixed left-0 top-0 w-64 h-full bg-gray-800 text-white p-4"
          style={{
            transition: "transform 0.3s ease-in-out",
            transform: "translateX(0)",
            opacity: 1,
            zIndex: 1000,
          }}
        >
          <button className="text-2xl absolute top-4 right-4" onClick={toggleDrawer} style={{ color: "white" }}>
            &#10005;
          </button>
          <nav className="flex flex-col space-y-4 mt-12">
            <Link to="/" onClick={handleLinkClick} style={{ color: isActive("/") ? "#ff7201" : "white" }}>
              Dashboard
            </Link>

            <Link to="/event-request" onClick={handleLinkClick} style={{ color: isActive("/event-request") ? "#ff7201" : "white" }}>
              Manpower/Event Request
            </Link>

            <Link to="/employees" onClick={handleLinkClick} style={{ color: isActive("/employees") ? "#ff7201" : "white" }}>
              Employees
            </Link>

            <Link
              to="/user-management"
              onClick={handleLinkClick}
              style={{
                color: isActive("/user-management") ? "#ff7201" : "white",
              }}
            >
              User Management
            </Link>

            <Link
              to="/recruitment"
              onClick={handleLinkClick}
              style={{
                color: location.pathname.startsWith("/recruitment") ? "#ff7201" : "white",
              }}
            >
              Recruitment
            </Link>
          </nav>
        </div>
      )}

      <Content
        style={{
          margin: "24px 16px",
          padding: 20,
          minHeight: 280,
        }}
      >
        <Outlet>{children}</Outlet>
      </Content>
    </Layout>
  );
};

export default PrivateLayout;
